<template>
  <div>
    <el-table
        :data="tracks.data"
        class="w100"
        stripe
        v-loading="loading"
    >
      <!-- Campaign Column -->
      <el-table-column label="Campaign">
        <template #default="props">
          <p v-for="campaign in props.row.campaigns" :key="campaign.campaign_id">
            {{ campaign.name || 'N/A' }}
          </p>
        </template>
      </el-table-column>

      <!-- Title and Label Columns -->
      <el-table-column label="Title" prop="title" sortable></el-table-column>
      <el-table-column label="Label" prop="label" sortable></el-table-column>

      <!-- Share Columns -->
      <el-table-column label="Label Share" align="right">
        <template #default="props">
          {{ getCampaignField(props.row.campaigns, 'label_share') }}%
        </template>
      </el-table-column>
      <el-table-column label="Platform Share" align="right">
        <template #default="props">
          {{ getCampaignField(props.row.campaigns, 'platform_share') }}%
        </template>
      </el-table-column>
      <el-table-column label="Cid Share" align="right">
        <template #default="props">
          {{ getPivotField(props.row.campaigns, 'cid_share') }}%
        </template>
      </el-table-column>

      <!-- AssetId Column -->
      <el-table-column label="AssetId" prop="id" align="right"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState('revShareCampaigns', ['tracks', 'loading']),
  },

  methods: {
    ...mapMutations('revShareCampaigns', ['setTrackModal']),
    ...mapActions('revShareCampaigns', ['readTracks']),

    /**
     * Safely get a field from the first campaign.
     */
    getCampaignField(campaigns, field) {
      if (!campaigns || !campaigns[0]) return 'N/A';
      return campaigns[0][field] || 'N/A';
    },

    /**
     * Safely get a pivot field from the first campaign.
     */
    getPivotField(campaigns, field) {
      if (!campaigns || !campaigns[0] || !campaigns[0].pivot) return 'N/A';
      return campaigns[0].pivot[field] || 'N/A';
    },
  },

  created() {
    this.readTracks();
    this.setTrackModal(false);
  },
};
</script>